var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Return Label Modal Component
 */
import React, { useCallback, useEffect } from 'react';
import { Modal, Form } from 'antd';
import { useTranslation } from 'react-i18next';
import Dropdown from '@fp-suite/core-ui/src/components/Dropdown';
import { usePackingState, usePackingActions } from '../../../hooks/packing';
import { useMediaQuery } from 'react-responsive';
export var ReturnLabelModal = function (_a) {
    var visible = _a.visible, onClose = _a.onClose, packageSeqId = _a.packageSeqId;
    var t = useTranslation().t;
    var form = Form.useForm()[0];
    var isMobileDevice = useMediaQuery({
        query: '(max-device-width: 640px)'
    });
    var _b = usePackingState(), shippingMethods = _b.shippingMethods, loading = _b.loading, loadShippingMethods = _b.loadShippingMethods, shipmentId = _b.shipmentId;
    var handleGetReturnLabel = usePackingActions().handleGetReturnLabel;
    // Load shipping methods
    useEffect(function () {
        if (visible && shippingMethods.length === 0 && shipmentId) {
            loadShippingMethods(shipmentId);
        }
    }, [visible, shippingMethods.length, loadShippingMethods, shipmentId]);
    // Handle submit
    var handleSubmit = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var values, carrierPartyId, shipmentMethodEnumId, _a, carrier, method, error_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!packageSeqId)
                        return [2 /*return*/];
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, form.validateFields()
                        // Parse carrier and method
                    ];
                case 2:
                    values = _b.sent();
                    carrierPartyId = void 0;
                    shipmentMethodEnumId = void 0;
                    if (values.carrierAndShipmentMethod) {
                        _a = values.carrierAndShipmentMethod.split(':'), carrier = _a[0], method = _a[1];
                        carrierPartyId = carrier;
                        shipmentMethodEnumId = method;
                    }
                    return [4 /*yield*/, handleGetReturnLabel({
                            shipmentPackageSeqId: packageSeqId,
                            carrierPartyId: carrierPartyId,
                            shipmentMethodEnumId: shipmentMethodEnumId
                        })];
                case 3:
                    _b.sent();
                    form.resetFields();
                    onClose();
                    return [3 /*break*/, 5];
                case 4:
                    error_1 = _b.sent();
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    }); }, [form, packageSeqId, handleGetReturnLabel, onClose]);
    // Build shipping method options: dynamic methods from store return settings + hardcoded fallback
    var shippingMethodOptions = __spreadArray(__spreadArray([], shippingMethods.map(function (method) {
        var _a;
        return ({
            key: method.carrierPartyId + ":" + method.shipmentMethodEnumId,
            value: method.carrierPartyId + ": " + ((_a = method.description) !== null && _a !== void 0 ? _a : method.shipmentMethodEnumId) + (method.shippingTotal != null ? " " + method.shippingTotal : '')
        });
    }), true), [
        { key: 'UPS Ground', value: 'UPS Ground' }
    ], false);
    return (_jsxs(Modal, __assign({ width: isMobileDevice ? '90%' : '50%', className: 'font-inter', title: t('Request Return Label'), visible: visible, onCancel: onClose, onOk: handleSubmit, okText: t('Generate Label'), confirmLoading: loading.returnLabel }, { children: [_jsx("p", __assign({ className: 'text-sm text-gray-600 mb-4' }, { children: t('Select a shipping method for the return label.') }), void 0), _jsx(Form, __assign({ form: form, layout: 'vertical' }, { children: _jsx(Form.Item, __assign({ name: 'carrierAndShipmentMethod', label: t('Shipping Method'), rules: [{ required: true, message: t('Please select a shipping method') }] }, { children: _jsx(Dropdown, { data: shippingMethodOptions, placeholder: t('Select Shipping Method'), onChange: function (value) { return form.setFieldsValue({ carrierAndShipmentMethod: value }); } }, void 0) }), void 0) }), void 0)] }), void 0));
};
export default ReturnLabelModal;
